import information from '@/views/mainContentProvince/information'

import standardManage from '@/views/mainContentProvince/information/standardManage'

import standardManageOrganization from '@/views/mainContentProvince/information/standardManage/organization'

import legal from '@/views/mainContentProvince/information/standardManage/organization/legal'
import system from '@/views/mainContentProvince/information/standardManage/organization/system'
import system1 from '@/views/mainContentProvince/information/standardManage/organization/system1'
import team from '@/views/mainContentProvince/information/standardManage/organization/team'

import goods from '@/views/mainContentProvince/information/standardManage/goods'

import goodsselect from '@/views/mainContentProvince/information/standardManage/goods/goodsselect'
import goodslogin from '@/views/mainContentProvince/information/standardManage/goods/goodslogin'
import goodsprotect from '@/views/mainContentProvince/information/standardManage/goods/goodsprotect'
import goodsbg from '@/views/mainContentProvince/information/standardManage/goods/goodsbg'

import open from '@/views/mainContentProvince/information/standardManage/open'
import infomations from '@/views/mainContentProvince/information/standardManage/open/infomations'
import visit from '@/views/mainContentProvince/information/standardManage/open/visit'

import safety from '@/views/mainContentProvince/information/standardManage/safety'
import realize from '@/views/mainContentProvince/information/standardManage/safety/realize'
import goodssafety from '@/views/mainContentProvince/information/standardManage/safety/goods'
import publics from '@/views/mainContentProvince/information/standardManage/safety/public'
import info from '@/views/mainContentProvince/information/standardManage/safety/info'


import service from '@/views/mainContentProvince/information/service'
import science from '@/views/mainContentProvince/information/service/science'
import output from '@/views/mainContentProvince/information/service/science/output'
import service1 from '@/views/mainContentProvince/information/service/science/service'


import list from '@/views/mainContentProvince/information/service/list'
import base from '@/views/mainContentProvince/information/service/list/base'
import shorttime from '@/views/mainContentProvince/information/service/list/shorttime'

import teac from '@/views/mainContentProvince/information/service/teac'
import explain from '@/views/mainContentProvince/information/service/teac/explain'
import exercise from '@/views/mainContentProvince/information/service/teac/exercise'
import appraisal from '@/views/mainContentProvince/information/service/teac/appraisal'


import culture from '@/views/mainContentProvince/information/service/culture'
import communication from '@/views/mainContentProvince/information/service/culture/communication'
import communicate from '@/views/mainContentProvince/information/service/culture/communicate'
import numbers from '@/views/mainContentProvince/information/service/culture/number'
import management from '@/views/mainContentProvince/information/service/culture/management'

import society from '@/views/mainContentProvince/information/society'
import audience from '@/views/mainContentProvince/information/society/audience'
import structure from '@/views/mainContentProvince/information/society/audience/structure'
import Satisfaction from '@/views/mainContentProvince/information/society/audience/Satisfaction'

import influence from '@/views/mainContentProvince/information/society/influence'
import follow from '@/views/mainContentProvince/information/society/influence/follow'
import reward from '@/views/mainContentProvince/information/society/influence/reward'
import participate from '@/views/mainContentProvince/information/society/influence/participate'

import special from '@/views/mainContentProvince/information/special'
import cut from '@/views/mainContentProvince/information/cut'
import synthesize from '@/views/mainContentProvince/information/synthesize'
import enclosure from '@/views/mainContentProvince/information/enclosure'
import download from '@/views/mainContentProvince/information/download'
import basemenu from '@/views/mainContentProvince/information/base'

import museumperson from '@/views/mainContentProvince/user'
import addmuseumperson from '@/views/mainContentProvince/user/listNew'

import specialist from '@/views/mainContentProvince/specialist'

import addspecialist from '@/views/mainContentProvince/specialist/listNew'

import country from '@/views/mainContentProvince/country'
import addcountry from '@/views/mainContentProvince/country/listNew'
import province from '@/views/mainContentProvince/province'
import addprovince from '@/views/mainContentProvince/province/listNew'
import museum from '@/views/mainContentProvince/statisticalQuery/museum'
import pfcx from '@/views/mainContentProvince/statisticalQuery/pfcx'
import progress from '@/views/mainContentProvince/processManagement'
import addaudit from '@/views/mainContentProvince/audit/addaudit'
import cutaudit from '@/views/mainContentProvince/audit/cutaudit'
import scoreadjust from '@/views/mainContentProvince/audit/scoreadjust'
import personinfo from '@/views/mainContentProvince/personinfo'
import otherfile from '@/views/mainContentProvince/information/otherfile'
import ranking from '@/views/mainContentProvince/statisticalQuery/ranking'
import pftj from '@/views/mainContentProvince/statisticalQuery/pftj'
import tongji from '@/views/mainContentProvince/tongji'
import paiming from '@/views/mainContentProvince/paiming'
import libraryUser from '@/views/mainContentCentral/libraryUser'
import editlibraryUser from '@/views/mainContentCentral/libraryUser/listNew/index'
export default {
  path: '/informationDeclarationProvince',
  component: information,
  exact: true,
  children: [
    {
      path: '/informationDeclaration/museumbaseinfoProvince',
      component: basemenu,
      exact: true,
    },
    {
      path: '/standardManageProvince',
      component: standardManage,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/standardManage/organizationProvince',
          component: standardManageOrganization,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/organization/legalProvince',
              component: legal,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/systemProvince',
              component: system,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/system1Province',
              component: system1,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/teamProvince',
              component: team,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/goodsProvince',
          component: goods,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/goods/goodsselectProvince',
              component: goodsselect,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsloginProvince',
              component: goodslogin,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsbgProvince',
              component: goodsbg,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsprotectProvince',
              component: goodsprotect,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/openProvince',
          component: open,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/open/infomationsProvince',
              component: infomations,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/open/visitProvince',
              component: visit,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/safetyProvince',
          component: safety,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/safety/realizeProvince',
              component: realize,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/goodsProvince',
              component: goodssafety,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/publicProvince',
              component: publics,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/infoProvince',
              component: info,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/serviceProvince',
      component: service,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/service/scienceProvince',
          component: science,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/science/outputProvince',
              component: output,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/science/serviceProvince',
              component: service1,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/listProvince',
          component: list,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/list/baseProvince',
              component: base,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/list/shorttimeProvince',
              component: shorttime,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/teacProvince',
          component: teac,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/teac/explainProvince',
              component: explain,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/exerciseProvince',
              component: exercise,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/appraisalProvince',
              component: appraisal,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/cultureProvince',
          component: culture,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/culture/communicationProvince',
              component: communication,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/communicateProvince',
              component: communicate,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/numberProvince',
              component: numbers,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/managementProvince',
              component: management,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/societyProvince',
      component: society,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/society/audienceProvince',
          component: audience,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/audience/structureProvince',
              component: structure,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/audience/SatisfactionProvince',
              component: Satisfaction,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/society/influenceProvince',
          component: influence,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/influence/followProvince',
              component: follow,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/rewardProvince',
              component: reward,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/participateProvince',
              component: participate,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/addition/specialProvince',
      component: special,
      exact: true,
    },
    {
      path: '/informationDeclaration/enclosureProvince',
      component: enclosure,
      exact: true,
    },
    {
      path: '/informationDeclaration/downloadProvince',
      component: download,
      exact: true,
    },
    {
      path: '/expert/museumgroupProvince',
      component: museumperson,
      exact: true,
    },
    {
      path: '/expert/addmuseumpersonProvince',
      component: addmuseumperson,
      exact: true,
    },
    {
      path: '/expert/specialistProvince',
      component: specialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/warningProvince',
      component: cut,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/proposalProvince',
      component: synthesize,
      exact: true,
    },
    {
      path: '/expert/addspecialistProvince',
      component: addspecialist,
      exact: true,
    },
    {
      path: '/person/userProvince',
      component: country,
      exact: true,
    },
    {
      path: '/person/userProvince/addcountryProvince',
      component: addcountry,
      exact: true,
    },
    {
      path: '/informationDeclaration/provinceProvince',
      component: province,
      exact: true,
    },
    {
      path: '/informationDeclaration/addprovinceProvince',
      component: addprovince,
      exact: true,
    },
    {
      path: '/query/statProvince',
      component: pftj,
      exact: true,
    },
    {
      path: '/query/museumProvince',
      component: museum,
      exact: true,
    },
    {
      path: '/query/scoreProvince',
      component: pfcx,
      exact: true,
    },
    {
      path: '/informationDeclaration/progressProvince',
      component: progress,
      exact: true,
    },
    {
      path: '/confirm/addauditProvince',
      component: addaudit,
      exact: true,
    },
    {
      path: '/confirm/cutauditProvince',
      component: cutaudit,
      exact: true,
    },
    {
      path: '/confirm/scoreadjustProvince',
      component: scoreadjust,
      exact: true,
    },
    {
      path: 'personinfo',
      component: personinfo,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/otherfileProvince',
      component: otherfile,
      exact: true,
    },
    {
      path: '/query/rankingProvince',
      component: ranking,
      exact: true,
    },
    {
      path: '/person/museumadminProvince',
      component: libraryUser,
      exact: true,
    },
    {
      path: '/person/addmuseumadminProvince',
      component: editlibraryUser,
      exact: true,
    },
    {
      path: '/query/finishProvince',
      component: tongji,
      exact: true,
    },
    // {
    //   path: '/query/statProvince',
    //   component: paiming,
    //   exact: true,
    // }
  ]
}
